import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypesFetchFailedAction = {
	type: 'DOCUMENT_TYPES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypesFetchFailedAction => ({
	type: 'DOCUMENT_TYPES_FETCH_FAILED',
	payload,
});
